import { FirebaseStorage, getStorage, connectStorageEmulator } from 'firebase/storage';
import { app } from './startFirestore';
import { environmentType, deploymentEnvironment, emulatorPorts } from '../config';

/**
 * Connect Storage emulator on development environment and local deployment
 * @param storage Firebase Storage instance
 */
export const connectStorageEmulatorOnDev = (storage: FirebaseStorage) => {
    if (environmentType === 'development' && deploymentEnvironment === 'local') {
        try {
            connectStorageEmulator(storage, 'localhost', emulatorPorts.storage);
            console.log('Connected to Firebase Storage emulator');
        } catch (error) {
            console.log('Firebase Storage emulator is not running');
        }
    }
};

// Initialize Firebase Storage
export const storage = getStorage(app);

// Connect to Storage emulator if in development
connectStorageEmulatorOnDev(storage); 